import React from 'react'
import { Grid, Theme } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import useFormikHelper from '../useFormikHelper'
import { ModificationValues } from '../enum'

const useStyle = makeStyles((theme: Theme) => {
  return {
    textStyle: {
      fontSize: theme.typography.pxToRem(16),
    },
    title: {
      fontWeight: 700,
    },
    sequence: {
      wordBreak: 'break-word',
    },
  }
})

const SequencePreview = () => {
  const classes = useStyle()
  const formik = useFormikHelper()
  const { fiveMod, sequence, threeMod } = formik.selectedOligoValues
  return (
    <Grid container className={classes.textStyle}>
      <Grid item xs={12} className={classes.title}>
        <FormattedMessage
          id="_PC_SEQUENCE_PREVIEW"
          defaultMessage="Sequence Preview"
        />
      </Grid>
      <Grid item className={classes.sequence}>
        {formik.errors?.sequence ? (
          '--'
        ) : sequence?.length === 0 ? (
          <FormattedMessage
            id="EMPTY_SEQUENCE_PREVIEW_TEXT"
            defaultMessage="Start typing sequence above to see the preview."
          />
        ) : (
          <>
            {fiveMod !== ModificationValues.None ? fiveMod : ''}
            {sequence}
            {threeMod !== ModificationValues.None ? threeMod : ''}
          </>
        )}
      </Grid>
    </Grid>
  )
}

export default SequencePreview
